import { createFileRoute } from "@tanstack/react-router";

import { requireSuperAdmin } from "@/features/auth/permissions/requireSuperAdmin";
import { SubCategoriesPage } from "@/features/mbc-admin/subcategories/SubCategoriesPage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/admin/subcategories/")({
  beforeLoad: ({ context }) => requireSuperAdmin(context),
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Subcategories");

  return <SubCategoriesPage />;
}
